import { createSvgIcon } from "@mui/material";

export const WebsiteIcon = createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path d="M8.79334 5.79202C9.67243 6.21174 10.293 7.03218 10.4576 7.99232C10.6222 8.95247 10.3104 9.93276 9.62134 10.6214L6.62134 13.6214C5.45054 14.7921 3.54947 14.7921 2.37867 13.6214C1.20787 12.4506 1.20787 10.5495 2.37867 9.37869L3.55 8.20735M12.45 7.79269L13.6213 6.62135C14.7921 5.45056 14.7921 3.54948 13.6213 2.37869C12.4505 1.20789 10.5495 1.20789 9.37867 2.37869L6.37867 5.37869C5.68959 6.06727 5.37776 7.04757 5.54238 8.00772C5.707 8.96786 6.32757 9.7883 7.20667 10.208" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>,
    'WebsiteIcon'
)
